import { render, staticRenderFns } from "./CollectionAccountTradeFlow.vue?vue&type=template&id=654bac4b&scoped=true"
import script from "./CollectionAccountTradeFlow.vue?vue&type=script&lang=js"
export * from "./CollectionAccountTradeFlow.vue?vue&type=script&lang=js"
import style0 from "./CollectionAccountTradeFlow.vue?vue&type=style&index=0&id=654bac4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bac4b",
  null
  
)

export default component.exports